// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"aeb3978d","488":"4e7c63e6","658":"5d536a5e","907":"c4d4499d"}[chunkId] + ".chunk.js";
};